import styled from 'styled-components';

export const HabitsListContainer = styled.div`
  padding: ${({ theme }) => `${theme.spacing(2)} 0 0`};
`;
